const messages = {
  en: {
    ["message-success"]: "Your account is now integrated.",
    ["message-error"]: "An unexpected error occurred. Please try again.",
    ["message-disconnected"]: "Your account is now disconnected.",
    ["message-disconnect-error"]:
      "There was an error disconnecting your account. Please try again.",
    ["message-change-plan-success"]:
      "Your subscription plan has been updated successfully.",
    ["message-cancel-subscription-success"]:
      "Your subscription cancellation has been submitted.",
    ["message-reactivate-success"]:
      "Subscription reactivated.",
  },
  fr: {
    ["message-success"]: "Votre compte est maintenant int\u00e9gr\u00e9.",
    ["message-error"]: "Une erreur inattendue s'est produite. Veuillez r\u00e9essayer.",
    ["message-disconnected"]: "Votre compte est maintenant d\u00e9connect\u00e9.",
    ["message-disconnect-error"]:
      "Une erreur s'est produite lors de la d\u00e9connexion de votre compte. Veuillez r\u00e9essayer.",
    ["message-change-plan-success"]:
      "Votre plan d'abonnement a \u00e9t\u00e9 mis \u00e0 jour avec succ\u00e8s.",
    ["message-cancel-subscription-success"]:
      "Votre demande d'annulation d'abonnement a \u00e9t\u00e9 soumise.",
    ["message-reactivate-success"]:
      "Abonnement r\u00e9activ\u00e9.",
  },
};

export default messages;

